import {useEffect, useState} from 'react';
import {dataMultiChart} from '../../utils/types/multiChart.types';
import {Grid} from '@mui/material';
import {LineBarDateMultiChar} from '../components/LineBarDateMultiChart';
import {useEstadisticasDsKey} from '../hooks/useEstadisticasDsKey';
import { mapperCantLlavesToDataMultiChar } from '../../utils/mappers/mapperCantLlavesToDataMultiChar';
import { useStylesBorder } from '../../utils/styles/styles';
interface LlavesChartProps {
   fecha: Date;
}

export const LlavesPorProducto: React.FC<LlavesChartProps> = ({
   fecha
}) => {
   const {classes} = useStylesBorder();
   const [dataMultiChart, setDataMultiChart] = useState<dataMultiChart[]>([]);
   const [dataResumen, setDataResumen] = useState<any[]>([]);
   const {getResumenLlaves} = useEstadisticasDsKey();
   const fetchResumen = async () => {
      const result = await getResumenLlaves({fecha: fecha});
      if (result) {
         setDataResumen(result);
      }
   };
   useEffect(() => {
      fetchResumen();
   }, []);
   useEffect(() => {
      if (dataResumen) {
         const newData = mapperCantLlavesToDataMultiChar({
            data: dataResumen,
         });
         setDataMultiChart(newData);
      }
   }, [dataResumen]);
   return (
      <Grid container className={classes.border}>
         <LineBarDateMultiChar
            titleLevel={{
               0: 'Llaves por Meses',
               1: 'Llaves por Producto',
               2: 'Llaves por Usuario',
               3: 'Llaves por Cliente'
            }}
            codIgnore="otros"
            data={dataMultiChart}
            defaultSlider={{end: fecha.getMonth(), start: 0}}
            maxColumns={{2: 5, 3:5}}
            minLevel={1}
            maxLevel={3}
         />
      </Grid>
   );
};
